import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { create } from 'zustand';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircleIcon, ExclamationTriangleIcon, XCircleIcon } from '@heroicons/react/24/outline';
let counter = 0;
const useToastStore = create((set, get) => ({
    items: [],
    push: (kind, message) => {
        const id = ++counter;
        set({ items: [...get().items, { id, kind, message }] });
        setTimeout(() => get().remove(id), 4000);
    },
    remove: (id) => set({ items: get().items.filter((i) => i.id !== id) }),
}));
export const toast = {
    success: (m) => useToastStore.getState().push('success', m),
    error: (m) => useToastStore.getState().push('error', m),
    info: (m) => useToastStore.getState().push('info', m),
};
const ICON = { success: CheckCircleIcon, error: XCircleIcon, info: ExclamationTriangleIcon };
const STYLE = {
    success: 'border-green-200 bg-green-50 text-green-800 dark:border-green-900 dark:bg-green-950 dark:text-green-200',
    error: 'border-red-200 bg-red-50 text-red-800 dark:border-red-900 dark:bg-red-950 dark:text-red-200',
    info: 'border-blue-200 bg-blue-50 text-blue-800 dark:border-blue-900 dark:bg-blue-950 dark:text-blue-200',
};
export function ToastViewport() {
    const items = useToastStore((s) => s.items);
    const remove = useToastStore((s) => s.remove);
    return (_jsx("div", { className: "pointer-events-none fixed bottom-4 start-4 z-[60] flex w-full max-w-sm flex-col gap-2", children: _jsx(AnimatePresence, { children: items.map((it) => {
                const Icon = ICON[it.kind];
                return (_jsxs(motion.div, { initial: { opacity: 0, y: 8 }, animate: { opacity: 1, y: 0 }, exit: { opacity: 0, y: 8 }, className: `pointer-events-auto flex items-start gap-2 rounded-lg border px-3 py-2 text-sm shadow-lg ${STYLE[it.kind]}`, role: "status", children: [_jsx(Icon, { className: "mt-0.5 h-4 w-4 shrink-0" }), _jsx("span", { className: "flex-1", children: it.message }), _jsx("button", { onClick: () => remove(it.id), className: "text-current opacity-60 hover:opacity-100", children: "\u00D7" })] }, it.id));
            }) }) }));
}
